/**
 * Rig State -> OPBridge doc-store sync.
 *
 * History. 2026-08-20 (OPBridge ask S226): Rig State (banks of captured
 * "looks", `rigState/store.ts`) is hand-authored data with no other copy, so
 * it began syncing through the generic consumer doc store, as ONE doc,
 * `rigstate`, holding the whole library (a clone of the Matrix's sync).
 *
 * 2026-10-06 (S305): one doc per bank and per look, merged record by record
 * (`sync/recordDocSync.ts`, records in `rigStateRecords.ts`). Two looks
 * captured into one bank on two PCs in one sync window now both survive; the
 * whole-library doc kept only one. The old `rigstate` doc is read once to
 * migrate and left untouched.
 *
 * localStorage remains the SOURCE OF TRUTH and the offline store.
 */

import { rigStateLibrary, setRigStateLibrary } from './store.ts';
import { rigStateAdapter } from './rigStateRecords.ts';
import { installRecordSync, type RecordSyncHandle } from '../sync/recordSyncWiring.ts';

/** Kill switch, a dedicated key so a smoke can disable Rig State sync
 *  independently of Matrix / Projects sync. */
const DISABLE_KEY = 'opbuttons.rigStateSync.disabled';
const MEMORY_KEY = 'opbuttons.rigStateSync.memory.v1';

let handle: RecordSyncHandle | null = null;
export function rigStateSync(): RecordSyncHandle | null { return handle; }

/** Wire the reactive effects. Call once at app boot. */
export function installRigStateSync(): void {
  handle = installRecordSync({
    adapter: rigStateAdapter,
    read: rigStateLibrary,
    write: setRigStateLibrary,
    disableKey: DISABLE_KEY,
    memoryKey: MEMORY_KEY,
  });
}
